import React, { useState } from "react";
import cx from "classnames";
import Card from "shared/Card";

import SurveyImg from "assets/img/coffeeGiftBox.jpg";
import Button from "shared/Button";

import styles from "./SurveyCard.module.scss";

import { setCookie, getCookie } from "shared/utility";

const SurveyCard = () => {
    const [surveyCookie, setSurveyCookie] = useState(getCookie("surveyCookie"));

    function handleSurveyOpen() {
        window.open("https://frankie807610.typeform.com/to/TQxvmRAR");
        setSurveyCookie(true);
        setCookie("surveyCookie", "surveyOpened", 60);
    }

    if (surveyCookie) {
        return null;
    }

    return (
        <Card className={styles.surveyCard}>
            <div className={styles.header}>
                <img
                    className={styles.thumbnail}
                    src={SurveyImg}
                    alt="A Grind gift box of coffee pods, a coffee and a pastry"
                />
                <div className={styles.copy}>
                    <h3>How's your coffee?</h3>
                    <p>
                        Let us know and get 15% off your next subscription
                        order!
                    </p>
                </div>
            </div>

            <div className={styles.actions}>
                <Button
                    size="lg"
                    className={styles.action}
                    onClick={handleSurveyOpen}
                >
                    Start survey
                </Button>
                <Button
                    btnType="secondary"
                    size="lg"
                    className={cx(styles.action, styles.secondaryAction)}
                    onClick={() => {
                        setCookie("surveyCookie", "postponed", 40);
                        setSurveyCookie(true);
                    }}
                >
                    Maybe later
                </Button>
            </div>
        </Card>
    );
};

export default SurveyCard;
